exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".dealers-title[data-v-58b3b28f]{font-weight:900}", "", {"version":3,"sources":["/home/webuser/tosol/releases/59/spa/src/pages/auth/register/Register.scss"],"names":[],"mappings":"AAAA,gCACE,eAAA,CAAA","file":"Register.scss?vue&type=style&index=0&id=58b3b28f&prod&lang=scss&scoped=true&","sourcesContent":[".dealers-title {\n  font-weight: 900;\n}\n"],"sourceRoot":""}]);

// exports
